import type { UseCase } from '@/core/shared'
import type { UserRepository } from '../domain'

export const inviteUsersToAccessConfig: UseCase<UserRepository, 'inviteUsersToAccessConfig'> = repository => {
  return async (inviteUsersToAccessConfig) => {
    await repository.inviteUsersToAccessConfig(inviteUsersToAccessConfig)
  }
}
